module.exports = __webpack_public_path__ + "front/img/69.41c337d5.jpg";